// extracted by mini-css-extract-plugin
export default {"page-layout-wrapper":"styles_page-layout-wrapper__6CHBP","notificationList":"styles_notificationList__D9EtO"};